import { FormattedMessage } from '@melio/ar-domain';
import { Group, Illustration, Text } from '@melio/penny';
import { forwardRef } from '@melio/platform-utils';
import React from 'react';

import { NewGuestPaymentLayout } from '../../../layout';

export type GuestPaymentErrorScreenProps =
  | {
      errorType: 'expired';
      vendorEmail: string;
    }
  | {
      errorType: 'network-error';
      vendorEmail?: never;
    };

export const GuestPaymentErrorScreen = forwardRef<GuestPaymentErrorScreenProps>(
  ({ errorType = 'network-error', vendorEmail }, ref) => {
    let title;
    let description;

    if (errorType === 'expired') {
      title = <FormattedMessage id="ar.newGuestPayment.errors.paymentLinkExipred.title.text" />;
      description = (
        <FormattedMessage id="ar.newGuestPayment.errors.paymentLinkExipred.description.text" values={{ vendorEmail }} />
      );
    } else {
      title = <FormattedMessage id="ar.newGuestPayment.errors.generalMessage.title.text" />;
      description = <FormattedMessage id="ar.newGuestPayment.errors.generalMessage.title.text" />;
    }

    return (
      <NewGuestPaymentLayout data-component={GuestPaymentErrorScreen.displayName} ref={ref}>
        <Group variant="vertical" spacing="s">
          <Illustration type={errorType} />
          <Group variant="vertical" spacing="none">
            <Text textStyle="heading3Semi">{title}</Text>
            <Text textStyle="body3">{description}</Text>
          </Group>
        </Group>
      </NewGuestPaymentLayout>
    );
  }
);

GuestPaymentErrorScreen.displayName = 'GuestPaymentErrorScreen';
